// @flow
import $ from 'jquery';
import 'velocity-animate';

/**
 * A user-controlled wipe between two images, one on the top (left),
 * and one on the bottom (right).
 *
 * Requires:
 * - Velocity  (http://VelocityJS.org)
 *
 * @param {Object} options
 */
export default (): void => {

  $.fn.wiper = function(options) {
 		var options = $.extend({
 			wiperInitialPosition  : 0.5,
 			wiperLayerClass		    : 'wiper__layer',
 			wiperTopLayerClass	  : 'wiper__layer--top',
 			wiperBottomLayerClass : 'wiper__layer--bottom',
 			wiperPullPoint        : 'wiper__pull-point',
 			wiperStyle		        : 'no', // css style for border eq.: '1px solid #000000'
 			resetSlideDelay	      : 2000,
 			resetSlideSpeed	      : 1000
 		}, options);

 		return this.each(function() {
 			var $container = $(this);
 			var $pullPoint = $("."+options.wiperPullPoint);
 			var $bottomLayer = null;
 			var $topLayer = null;
 			var $images = null;
 			var resetAnimation = null;
 			var trackedTouch = -1;

 			function init()
 			{
 				// wait for the images to be loaded before doing anything
 				$images = $container.find('img');
        if($images.length > 0) {
          $container.data('initiate', true);

          var $layers = $container.find("."+options.wiperLayerClass);
          $bottomLayer = $layers.eq(0);
          $topLayer = $layers.eq(1);

          $topLayer.css({'border-right': options.wiperStyle});

          updateWiper(options.wiperInitialPosition);

          calculateDimension();

          bindEvents();

        }
 			}

 			/**
 			 * Update the position of the wiper.
 			 */
 			function updateWiper(pc)
 			{
 				if (pc < 0.0) {
 					pc = 0.0;
 				}

 				var topLayerWidth = (pc * 100) + '%';

 				if (pc >= 0.999) {
 					// abandon percentages and force it to the right edge!
 					topLayerWidth = 'calc(100% - ' + $topLayer.css('borderRightWidth') + ')';
 				}

 				$topLayer.css({'width': topLayerWidth});
 			}

 			/**
 			 * Put the wiper to it's initial position and reset binds.
 			 */
 			function resetWiper()
 			{
        // initial position
        var initToPercent = (options.wiperInitialPosition * 100);
        var topLayerWidth = $topLayer.width() / $topLayer.parent().width() * 100;
        // console.log("init: "+initToPercent);
        // console.log("aktual: "+topLayerWidth);
        // console.log("============================");
        if(initToPercent != topLayerWidth) {
          $topLayer.velocity(
            {
              width: initToPercent + '%'
            },
            {
              queue: false,
              duration: options.resetSlideSpeed
            }
          );
        }
        // reset binds
        $container.off();
 			}

      /**
       * Start update wiper on hover pull point...
       */
      function startMove()
 			{

        $container.on('mousemove', function(event) {
            var relX = event.pageX - $(this).offset().left;
            updateWiper(relX / $(this).width());
        });

        $container.on('mouseleave', function(event) {
          var relX = event.pageX - $(this).offset().left;
            updateWiper(relX / $(this).width());

            if (options.resetSlideDelay > -1) {
              resetAnimation = setTimeout(function() {
                resetWiper();
              }, options.resetSlideDelay);
            }
        });
 			}

      /**
       * Start update wiper on touch pull point...
       */
      function startTouch()
      {

        $container.on('touchmove', function(event) {
          if (!event.originalEvent) {
            return;
          }

          var touches = event.originalEvent.changedTouches;

          if (trackedTouch == null) {
            return;
          }

          for (var i = 0; i < touches.length; i++) {
            if (touches[i].identifier == trackedTouch) {
              event.preventDefault();

              var relX = touches[i].pageX - $(this).offset().left;
                updateWiper(relX / $(this).width());

              break;
            }
          }
        });

        $container.on('touchend touchcancel', function(event) {
          trackedTouch = -1;

            if (options.resetSlideDelay > -1) {
              resetAnimation = setTimeout(function() {
                resetWiper()
              }, options.resetSlideDelay);
            }
        });

      }

 			/**
 			 * Attach events.
 			 */
 			function bindEvents()
 			{
 				// desktops
        $pullPoint.on('mouseenter', function(event) {
 					clearTimeout(resetAnimation);
          startMove();
 				});

 				$(window).resize(function() {
 					calculateDimension();
 				});

 				// mobile devices
        $pullPoint.on('touchstart', function(event) {
 					clearTimeout(resetAnimation);

 					if (!event.originalEvent) {
 						return;
 					}

 					// only track single-finger touches
 					if (event.originalEvent.changedTouches.length == 1) {
 						event.preventDefault();
 						trackedTouch = event.originalEvent.changedTouches[0].identifier;
 					}

          startTouch();
 				});

 			}

 			/**
 			 * Resize the images to make them fit the container.
 			 */
 			function calculateDimension()
 			{
 				var $width = $container.width() + 'px';
 				$images.css({'width': $width, 'max-width':'none'});
 			}

 			/**
 			 * Initiate the plugin once all the images are loaded
 			 * (as long as it hasn't already been initiated)
 			 */
 			if(!$container.data('initiate')) {
 				init();
 			}
 		});
 	};

  $(function () {
    $('.wiper').wiper();
  });

};



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/wiper.js